"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetPromocodeByCode = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var CURRENT_CODE = 'current_promocode';
var useGetPromocodeByCode = function (code) {
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    var _b = (0, useQuery_1.useQuery)({
        path: keys_1.PROMO_BY_CODE,
        payload: { code: code },
        canRender: !!code,
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, isValidating = _b.isValidating, mutate = _b.mutate;
    (0, react_1.useEffect)(function () {
        var prevCode = getDataFromCache(CURRENT_CODE);
        if (prevCode !== code) {
            mutate();
            setDataToCache(CURRENT_CODE, code);
        }
    }, [code, getDataFromCache, setDataToCache, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data, isLoading, isValidating, error]);
};
exports.useGetPromocodeByCode = useGetPromocodeByCode;
